<div class="bg-white rounded-md p-6 pb-20 mb-20">
  <div class="flex items-center justify-between mb-6">
    <h2 class="text-xl font-bold text-gray-800">
      <span class="sm:hidden">Experiencia laboral</span>
      <span class="hidden sm:block">Tu experiencia laboral</span>
    </h2>

    <button
      (click)="openAddModal()"
      class="bg-primary text-white px-4 py-2 rounded hover:opacity-90 transition flex items-center justify-center gap-2"
    >
      <ng-icon name="heroPlus" size="18"></ng-icon>

      <span class="hidden sm:block">Agregar experiencia</span>
    </button>
  </div>
  <app-loading *ngIf="isLoading" text="Cargando experiencias"> </app-loading>
  <ng-container *ngIf="!isLoading">
    <div
      *ngIf="experiences.length === 0"
      class="text-center text-gray-500 py-10 h-96"
    >
      <ng-icon
        name="heroBriefcase"
        size="40"
        class="mx-auto mb-2 text-gray-400"
      ></ng-icon>
      <p>No tienes experiencias registradas aún.</p>
    </div>
    <div
      *ngIf="experiences.length > 0"
      class="grid grid-cols-1 md:grid-cols-3 gap-6"
    >
      <div
        *ngFor="let exp of experiences"
        class="border border-gray-200 rounded-xl p-5 flex flex-col gap-4"
      >
        <div class="flex items-start gap-4 justify-between">
          <div class="flex items-center gap-2 grow min-w-0">
            <div
              class="w-12 h-12 rounded-lg bg-gray-100 flex items-center justify-center shrink-0"
            >
              <ng-icon
                name="heroBuildingOffice"
                class="text-gray-600"
                size="24"
              ></ng-icon>
            </div>
            <div class="min-w-0 max-w-full">
              <p class="text-gray-800 font-medium truncate max-w-full">
                {{ exp.companyName }}
              </p>
              <p class="text-primary font-bold text-lg truncate max-w-full">
                {{ exp.jobTitle.name }}
              </p>
            </div>
          </div>
          <div class="flex gap-2 shrink-0">
            <button
              (click)="openUpdateModal(exp)"
              class="text-gray-600 hover:text-primary cursor-pointer flex items-center justify-center"
            >
              <ng-icon name="heroPencilSquare" size="24"></ng-icon>
            </button>
            <button
              (click)="openDeleteModal(exp)"
              class="text-gray-600 hover:text-red-400 cursor-pointer flex items-center justify-center"
            >
              <ng-icon name="heroTrash" size="24"></ng-icon>
            </button>
          </div>
        </div>
        <div class="flex flex-wrap gap-2">
          <span
            class="px-3 py-1 text-xs bg-primary/10 text-primary rounded-full truncate max-w-[8rem]"
          >
            {{ exp.businessLine.description }}
          </span>
          <span
            class="px-3 py-1 text-xs bg-gray-100 text-gray-700 rounded-full truncate"
          >
            {{ exp.area.name }}
          </span>
        </div>
        <p class="text-gray-600 text-sm leading-relaxed">
          {{ exp.functionsDescription }}
        </p>
        <div class="flex items-center justify-end text-sm text-gray-500 gap-2">
          <ng-icon name="heroCalendarDays" size="16"></ng-icon>
          <span
            >{{ exp.fromProperty | date : "MMM yyyy" }} -
            {{ exp.until | date : "MMM yyyy" }}</span
          >
        </div>
        <div
          *ngIf="exp.references && exp.references.length > 0"
          class="bg-gray-50 rounded-lg p-3 text-sm"
        >
          <p class="font-medium text-gray-700 mb-2">Referencias:</p>
          <div
            *ngFor="let ref of exp.references"
            class="flex items-center justify-between border-b border-gray-200 last:border-0 py-1"
          >
            <span class="text-gray-800 truncate">{{
              ref.fullNameContact
            }}</span>
            <span
              *ngIf="ref.telfContact"
              class="flex items-center gap-1 text-gray-600 shrink-0"
            >
              <ng-icon name="heroPhone" size="14"></ng-icon>
              {{ ref.telfContact }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<app-add-experince
  *ngIf="showAddModal"
  (close)="closeAddModal()"
  (save)="onSave()"
>
</app-add-experince>
<app-update-experience
  [experience]="selectedExperience"
  *ngIf="showUpdatingModal"
  (close)="closeUpdateModal()"
  (save)="onUpdate($event)"
>
</app-update-experience>
<div
  *ngIf="showDeleteModal"
  class="fixed inset-0 bg-black/60 bg-opacity-60 flex items-center justify-center z-50"
>
  <div class="bg-white rounded-lg shadow-lg max-w-sm w-full p-6 text-center">
    <h2 class="text-lg font-semibold text-gray-800 mb-4">
      ¿Estás seguro que deseas eliminar?
    </h2>
    <div class="flex justify-center gap-4">
      <button
        (click)="closeDeleteModal()"
        class="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
      >
        Cancelar
      </button>
      <app-loading-button
        (click)="confirmDelete()"
        [text]="'Eliminar'"
        [loading]="isDeleting"
        type="button"
      >
      </app-loading-button>
    </div>
  </div>
</div>
